import ServiceApi from "./service";
let Service = ServiceApi.service
// 所有的接口都要定义在该文件
export default {
	// // 验证码
	// captcha(params) {
	// 	return Service.get("/api/user/captcha", params);
	// },
	// 登录
	login(params) {
		return Service.post("/admin/v1/login", params);
	},
	// 职位分类
	pocate(params = {}) {
		return Service.post("/v1/index/cate", params);
	},
	// 职位列表
	lists(params = {}) {
		return Service.post("/v1/index/lists", params);
	},
	// 职位详情
	details(params = {}) {
		return Service.post("/v1/index/details", params);
	},
	// 推荐职位 /v1/index/getPosition
	getPosition(params = {}) {
		return Service.post("/v1/index/getPosition", params);
	},
	// 轮播图 v1/index/banner
	banner(params = {}) {
		return Service.post("/v1/index/banner", params);
	},
	// 求职登记  v1/index/position
	position(params = {}) {
		return Service.post("/v1/index/position", params);
	},
	// 发送验证吗 /v1/api/sms
	sms(params = {}) {
		return Service.post("/v1/api/sms", params);
	},
};